/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfcraft_LicenseInputs */

const en_pc_alt_t_pdfcraft_license = /** @type {(inputs: Pc_Alt_T_Pdfcraft_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source (MIT or Apache-2.0)`)
};

const zh_pc_alt_t_pdfcraft_license = /** @type {(inputs: Pc_Alt_T_Pdfcraft_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源（MIT 或 Apache-2.0）`)
};

/**
* | output |
* | --- |
* | "Open source (MIT or Apache-2.0)" |
*
* @param {Pc_Alt_T_Pdfcraft_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfcraft_license = /** @type {((inputs?: Pc_Alt_T_Pdfcraft_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfcraft_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfcraft_license(inputs)
	return zh_pc_alt_t_pdfcraft_license(inputs)
});
export { pc_alt_t_pdfcraft_license as "pc.alt.t.pdfcraft.license" }